import { EMPTY_STRING } from '@common/constants';
import { isString } from 'lodash';
import { ReactElement } from 'react';

export const isEmptyStringDate = (date: string | number | null | ReactElement | boolean | Array<any> | object | undefined | Date) => {
  return isString(date) && date === EMPTY_STRING;
};

